import React from "react";
import aboutUs from "../../PicesForPages/AboutUs.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function AboutUs() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent aboutUsTopParent">
        <img
          src={aboutUs}
          alt="aboutUsImage"
          className="background-video aboutUsImage"
        />
        <div className="purchasetopBox aboutUsTopBox">
          {/* The existing Purchase span */}
          <span>About Us</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              At <span className="brand_text">VIDHI MORTGAGE LLC</span> our
              mission is simple —{" "}
              <b>
                to guide every client through the right path to homeownership
                with clarity, integrity, and confidence.
              </b>
            </span>
            <span className="purchaseBottomLeftContent">
              The name Vidhi reflects our core philosophy:{" "}
              <b>
                a structured and trusted way of doing things, guided by the
                right path.{" "}
              </b>
              We bring this meaning into every client interaction, ensuring that
              your mortgage journey is handled with care, transparency, and a
              personalized approach.
            </span>
            <span className="purchaseBottomLeftContent">
              We understand that no two borrowers are the same. That’s why we
              don’t rely on generic, one-size-fits-all solutions. Instead, we
              take the time to understand your financial goals and tailor loan
              options that truly fit your needs.
            </span>

            <span className="purchaseBottomLeftContent">
              Through our strong relationships with{" "}
              <b>100+ lending partners,</b> including top-tier financial
              institutions and specialized investors, we provide access to a
              wide range of competitive mortgage solutions. Whether your
              scenario is straightforward or complex, we are equipped to help
              you navigate it with confidence.
            </span>

            <span className="purchaseBottomLeftContent ">
              Our expertise spans across a variety of loan programs, including:
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL purchaseBottomLeftContentmarginTop00">
              <li>Conventional and Jumbo loans</li>
              <li>VA loans</li>
              <li>Fixed-rate and Adjustable-rate mortgages (ARMs)</li>
              <li>Home Equity Lines of Credit (HELOCs)</li>
              <li>Commercial and investment property financing</li>
            </ul>
            <span className="purchaseBottomLeftContent">
              We also specialize in serving diverse borrower needs, including{" "}
              <b>
                first-time homebuyers, real estate investors, and clients
                seeking alternative documentation solutions.
              </b>
            </span>
            <span className="purchaseBottomLeftContent">
              At <span className="brand_text">VIDHI MORTGAGE LLC</span> we are
              committed to more than just closing loans—we are dedicated to
              building lasting relationships and helping our clients make
              informed financial decisions.
            </span>
            <br />
            <span className="purchaseBottomRightHeading">
              Your Journey. Our Guidance. The Right Way Forward.
            </span>

            <br />
            <br />
            <div className="purchaseBottomLeftButton">
              <a
                href="https://vidhimortgage.my1003app.com/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
